<template>
  <div :class="$style.container">
    <div :class="[$style.item, $style.apartments]">
      <elsa-v-select
        :options="apartmentsTypes"
        v-model="data.apartmentsType"
        label="name"
        :reduce="item => item.id"
        :clearable="false"
        :disabled="apartmentsTypes.length < 2"
        htmlLabel="Тип помещения"
      />
    </div>

    <div :class="$style.item">
      <label class="vs-select--label block">Дата создания документа</label>
      <div :class="$style.interval">
        <elsa-v-datepicker
          :class="$style.date"
          v-model="data.createDate.from"
        />
        <div :class="$style.dash">-</div>
        <elsa-v-datepicker
          :class="$style.date"
          v-model="data.createDate.to"
        />
      </div>
    </div>

    <div :class="$style.item">
      <label class="vs-select--label block">Сумма задолженности</label>
      <div :class="$style.interval">
        <vs-input
          :class="$style.date"
          v-model="data.sum.from"
          v-currency
          @keydown.enter="updateFilter"
        />
        <div :class="$style.dash">-</div>
        <vs-input
          :class="$style.date"
          v-model="data.sum.to"
          v-currency
          @keydown.enter="updateFilter"
        />
      </div>
    </div>

<!--    <div :class="$style.item">-->
<!--      <label class="vs-select&#45;&#45;label block">Оплатить до</label>-->
<!--      <div :class="$style.interval">-->
<!--        <elsa-v-datepicker-->
<!--          :class="$style.date"-->
<!--          v-model="data.dateDebtClose.from"-->
<!--        />-->
<!--        <div :class="$style.dash">-</div>-->
<!--        <elsa-v-datepicker-->
<!--          :class="$style.date"-->
<!--          v-model="data.dateDebtClose.to"-->
<!--        />-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  name:  "NotifiesFilter",
  props: ['onChange'],
  data() {
    return {
      data: {
        apartmentsType: null,
        createDate:     { from: null, to: null },
        sum:            { from: null, to: null },
        dateDebtClose:  { from: null, to: null },
      },
    };
  },
  computed: {
    apartmentsTypes() {
      return [
        { id: null, name: 'Все' },
        ...this.$store.getters['appUser/availableApartmentsTypes'],
      ];
    },
  },
  methods:  {
    updateSelectedApartmentsType() {
      if (this.apartmentsTypes.length === 1) {
        this.selectedApartmentsType = this.apartmentsTypes[0].id;
      } else if (this.apartmentsTypes.length > 1) {
        this.selectedApartmentsType = null;
      }
    },

    updateFilter() {
      const { onChange } = this;
      onChange && onChange({ ...this.data });
    },
  },
  watch:    {
    apartmentsTypes() {
      this.updateSelectedApartmentsType();
    },
    'data.apartmentsType': 'updateFilter',
    'data.createDate':     { deep: true, handler: 'updateFilter' },
    'data.dateDebtClose':  { deep: true, handler: 'updateFilter' },
  },
};
</script>

<style lang="scss" module>
.container {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  position: relative;
  margin: -0.5em;
  //@media screen and (max-width: $breakpoint) {
  //  flex-wrap: nowrap;
  //}
}

.item {
  margin: .25em .5em;
}

.apartments {
  width: 200px;
}

.interval {
  display: flex;
  align-items: flex-start;
}

.date {
  width: 100px;
}

.dash {
  margin: 9px 3px 0;
}
</style>
